import { Modal, ModalProps } from "react-bootstrap";

interface MainMenuModalProps extends ModalProps {
    onHide: () => void;
}

const ExitModal = (props: MainMenuModalProps) => {
    return (
        <Modal
            {...props}
            className={`mainMenuModal confirmationModal`}
            keyboard={false}
            centered
            scrollable={false}
            onHide={props.onHide}
        >
            <Modal.Body className="px-0">
                <div className="otpModalBody py-2">
                    <div className="header">
                        Are you sure you want to exit?
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-3">
                        <button className="btnYesMenu" onClick={props.handleSubmit}>
                            Yes
                        </button>
                        <button className="btnCancelMenu" onClick={() => props.onHide()}>
                            No
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ExitModal;
